<router-outlet></router-outlet>

<audio #chat>
    <source src="../assets/iphone.mp3" type="audio/mp3"/>
</audio>

<audio #notification>
    <source src="../assets/notification.mp3" type="audio/mp3"/>
</audio>

<audio #notification_tone>
    <source src="../assets/notification_tone.mp3" type="audio/mp3"/>
</audio>
